import MicrosoftTranslate from '@knowledge/knowledges/singleManage/microsoftTranslate';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { castArray, isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { Spin } from 'antd';
export const microTrans = new MicrosoftTranslate('en');
export const MicroTrans = (props: { text?: string }) => {
  const { text } = props;
  const lang = useSystemLanguageValue();
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (text === undefined) return;
    setLoading(true);
    microTrans
      .getTranslate(castArray(text))
      .then((res) => {
        setResult(res.get(text) || text);
      })
      .catch(() => {
        setResult(text);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [text]);
  if (isEmpty(text)) return <></>;
  if (lang === 'zh-CN') return <>{text}</>;
  if (loading) return <Spin size="small" />;
  return <>{result}</>;
};
